'use client';

import React, { useEffect, useMemo } from 'react';
import GlobalContext from './context';
import type { GlobalContextProviderProps, GlobalContextState } from './types';
import { rootReducer } from './reducers';
import { defaultState } from './reducers/constants';
import { setUser } from '@sentry/nextjs';
const GlobalContextProvider = ({
  children,
  initialValue = defaultState
}: GlobalContextProviderProps) => {
  const [state, dispatch] = React.useReducer(rootReducer, initialValue);
  useEffect(() => {
    setUser(initialValue?.user);
  }, [initialValue]);

  // Stable identity unless state changes; dispatch from useReducer is already stable.
  // Without this every consumer re-renders on any provider render.
  const contextValue: GlobalContextState = useMemo(() => ({
    state,
    dispatch
  }), [state]);
  return <GlobalContext.Provider value={contextValue} data-sentry-element="unknown" data-sentry-component="GlobalContextProvider" data-sentry-source-file="provider.tsx">
      {children}
    </GlobalContext.Provider>;
};
export default GlobalContextProvider;